
<template>
  <div class="indexnew">
    <div class="twobox">
      <div class="index_part_title">
        <span>
          <i class="el-icon-s-custom"></i>数据图
          <el-date-picker
            v-model="queryForm.time"
            type="date"
            placeholder="选择日期"
            size="mini"
            @change="dateChange"
            value-format="timestamp"
          >
          </el-date-picker>
        </span>

        <i class="el-icon-refresh refresh" @click="refresh('dau')"></i>
      </div>
      <div class="index_two_body index-chart-grid">
        <div
          class="echarts_box"
          ref="echarts_dau_ref"
          style="width: 100%; height: 300px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
let dauOption = {
  title: {
    text: "24小时用户登入日活",
  },
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: [],
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  yAxis: {
    type: "value",
  },
  series: [],
};
export default {
  data() {
    return {
      data: {},
      dauEcahrt: null,
      chartResizeObserver: null,
      dateValue: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        time: new Date().getTime(),
      },
    };
  },

  methods: {
    resizeChart() {
      if (this.dauEcahrt && !this.dauEcahrt.isDisposed()) {
        this.dauEcahrt.resize();
      }
    },
    bindChartResizeObserver() {
      if (typeof window !== "undefined" && "ResizeObserver" in window) {
        this.chartResizeObserver = new window.ResizeObserver(this.resizeChart);
        if (this.$refs.echarts_dau_ref) {
          this.chartResizeObserver.observe(this.$refs.echarts_dau_ref);
        }
      } else {
        window.addEventListener("resize", this.resizeChart);
      }
    },
    unbindChartResizeObserver() {
      window.removeEventListener("resize", this.resizeChart);
      if (this.chartResizeObserver) {
        this.chartResizeObserver.disconnect();
        this.chartResizeObserver = null;
      }
    },
    dateChange(e) {
      this.getDauEcahrt();
    },
    async getData() {
      let data = await this.$api.getData.getAllData();
      this.data = data.data.data;
    },
    async getDauEcahrt() {
      // 销毁旧的图表实例（关键修复）
      if (this.dauEcahrt) {
        this.dauEcahrt.dispose();
      }

      // 初始化新实例
      this.dauEcahrt = echarts.init(this.$refs.echarts_dau_ref);

      const loading = this.$loading({
        lock: true,
        text: "加载中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const { data } = await this.$api.getApp.getAppDau(this.queryForm);

        // 更新配置
        dauOption.xAxis.data = data.xAxis.map((item) => item.display);
        dauOption.legend.data = data.legend;
        dauOption.series = data.series;

        this.dauEcahrt.setOption(dauOption);

        // 强制重绘图表（可选）
        this.dauEcahrt.resize();
      } finally {
        loading.close();
      }
    },
    refresh(key) {
      if (key === "dau") {
        this.getDauEcahrt();
      }
    },
  },
  created() {
    this.getData();
  },
  components: {},
  mounted() {
    this.bindChartResizeObserver();
    this.getDauEcahrt();
  },
  beforeDestroy() {
    this.unbindChartResizeObserver();
    if (this.dauEcahrt && !this.dauEcahrt.isDisposed()) {
      this.dauEcahrt.dispose();
      this.dauEcahrt = null;
    }
  },
};
</script>
<style lang="less" scoped>
.twobox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 5px 20px #e4e4e4;
  border-radius: 5px;
  overflow: auto;
}

.index_two_body {
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  .index_two_item:not(:last-child) {
    margin-right: 15px;
  }
  .index_two_item {
    flex: 1;
    height: 170px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    background-color: #fbfbfb;
    padding: 0 15px;
    > div {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e8eaec;
      > img {
        width: 45px;
      }
      > div {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: flex-start;
        > p:nth-of-type(1) {
          font-size: 20px;
          font-weight: 400;
          color: #515a6e;
          line-height: 50px;
        }
        > p:nth-of-type(2) {
          font-size: 15px;
          color: #212121;
        }
      }
    }
    > p {
      width: 100%;
      height: 40px;

      font-size: 16px;
      color: #8c8c8c;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      > span {
        font-size: 15px;
        margin-right: auto;
      }
    }
  }
}
.index_part_title {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  border-bottom: 1px solid #e8eaec;
  margin-top: 12px;
}

.index_part_title span {
  font-size: 16px;
  margin-right: auto;
  font-weight: bold;
}
.index_part_title i {
  color: #1890ff;
  background-color: #e6f7ff;
  border-radius: 50%;
  padding: 4px;
  font-size: 16px;
  margin-right: 5px;
}

@media (max-width: 767px) {
  .twobox {
    overflow: hidden;
  }

  .index_part_title {
    height: auto;
    min-height: 50px;
    padding: 8px 10px;

    > span {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    /deep/ .el-date-editor {
      width: 100%;
      margin-top: 4px;
    }
  }

  .index-chart-grid {
    padding: 10px;

    .echarts_box {
      width: 100% !important;
      height: 300px !important;
    }
  }
}

// .indexnew {
//   width: 100%;
//   height: 100%;
//   background-color: #f5f7f9;
//   overflow: auto;
//   padding: 20px 20px 20px 20px;
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   color: #111;
// }
</style>
